// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#follower-list[data-v-ce353a44]{max-width:1280px;margin-left:auto;margin-right:auto}#follower-list .box-header .title[data-v-ce353a44]{font-size:22px;font-weight:700}#follower-list .box-header .spinner[data-v-ce353a44]{width:16px;height:16px;color:#c9cdd4}#follower-list .box-header .follower-count[data-v-ce353a44]{font-weight:700}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
